<div class="tree-view-container">
    <div class="tree-view-section-header" [ngClass]="{'collapsed': isCollapsed}">
        <span *ngIf="!isCollapsed">{{'AIFORPROCESSES.MY_PROCESSES' | translate}}</span>
        <bzg-icon [nameIcon]="isCollapsed ? 'icon-expand-panel' : 'icon-close-panel'" [size]="14" class="toggle-icon" (click)="toggleCollapse()"></bzg-icon>
    </div>

    <div class="tree-view-section-body" *ngIf="!isCollapsed">
        <app-processes-tree-view-node 
            *ngFor="let node of nodes" 
            [node]="node" 
            (selectedNode)="onSelect($event)" 
            (nodeToggled)="onNodeToggled($event)">
        </app-processes-tree-view-node>
    </div>
</div>